export const USERS_ROLE_BULK_UPDATE = '/account/userroles/bulk-update/';
